/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type ChangeCardPinResponseProductCardImageDetailsOneOfCardOrientation = typeof ChangeCardPinResponseProductCardImageDetailsOneOfCardOrientation[keyof typeof ChangeCardPinResponseProductCardImageDetailsOneOfCardOrientation];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChangeCardPinResponseProductCardImageDetailsOneOfCardOrientation = {
  LANDSCAPE: 'LANDSCAPE',
  PORTRAIT: 'PORTRAIT',
} as const;
